"use strict";

exports.__esModule = true;
exports.ChangePartInstanceActionElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Timeline = require("../../Timeline");
var _ChangePartFeatureDialog = require("../Dialogs/ChangePartFeatureDialog");
var _ManualEventsContext = require("../../Operator/ManualEventsContext");
var _Translator = require("../../Core/Translator");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ChangePartInstanceActionElement = exports.ChangePartInstanceActionElement = function ChangePartInstanceActionElement(props) {
  // state
  var _useState = (0, _react.useState)(false),
    isDialogOpen = _useState[0],
    setIsDialogOpen = _useState[1];

  // context
  var _React$useContext = _react["default"].useContext(_ManualEventsContext.ManualEventsContext),
    changePartInstance = _React$useContext.changePartInstance;
  var _React$useContext2 = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext2.translate;
  var toggleDialog = function toggleDialog() {
    setIsDialogOpen(!isDialogOpen);
  };
  var invoke = function invoke() {
    setIsDialogOpen(true);
  };
  var childProps = {
    invoke: invoke
  };
  if (!isDialogOpen) {
    return props.children(childProps);
  }
  var label = props.label || translate("UserAction.ChangePartInstance.label", "Change Part Instance");
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.children(childProps), /*#__PURE__*/_react["default"].createElement(_ChangePartFeatureDialog.ChangePartFeatureDialog, {
    label: label,
    timelineName: _Timeline.TIME_SERIES_INSTANCE,
    isOpen: isDialogOpen,
    toggleDialog: toggleDialog,
    handleSubmit: changePartInstance
  }));
};